module.exports = __webpack_public_path__ + "img/strap length.cd882dc9.png";